import type { ComponentPropsWithRef, FC } from 'react'

import { createPortal } from 'react-dom'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import 'react-tooltip/dist/react-tooltip.css'
import './styles.scss'

export type TooltipSize = 'base' | 'large'

export const Tooltip: FC<{ size?: TooltipSize } & ComponentPropsWithRef<typeof ReactTooltip>> = ({
  size = 'base',
  className,
  ...props
}) =>
  createPortal(
    <ReactTooltip className={`ui-tooltip ${size} ${className}`} {...props} />,
    document.body
  )
